import React, { Component } from 'react';
import greencheck from '../../images/greencheck.png'
import { Container, Row, Col, Button } from 'reactstrap';

export default class Confirmation extends Component {
    constructor(props) {
        super(props)

        this.state = {};
    }

    render() {
        return (
            <div>
                <br />
                <Container>
                    <Row className="justify-content-center">
                        <Col className="col-12 text-center">
                            <img src={greencheck} alt="success" height="50" width="50" />
                        </Col>
                    </Row>
                    <br />
                    <Row className="justify-content-center">
                        <Col className="col-12 text-center">
                            <p className="font-weight-bold">Success!</p>
                        </Col>
                    </Row>
                    <Row className="justify-content-center">
                        <Col className="col-12 text-center">
                            <p>Your profile has been created</p>
                        </Col>
                    </Row>
                    <Row className="justify-content-center">
                        <Col className="col-12 text-center">
                            <p className="font-weight-bold">Click on the button below to visit your Boards and Commissions Dashboard</p>
                            <Button id="goToDashboard" color="primary" onClick={this.props.goToDashboard}>Go To Dashboard</Button>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}